import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useState } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { normalizePhoneNumber } from '@chegg-ui/utils';
import { FloatingInputWrapper } from '@chegg-ui/input-wrapper';
import { getThemeConfig } from '../externals';
import { FloatingStyledInput } from '../styles';
var FloatingInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var inputId = props.inputId,
      errorText = props.errorText,
      errorCta = props.errorCta,
      className = props.className,
      leadingIcon = props.leadingIcon,
      trailingIcon = props.trailingIcon,
      value = props.value,
      disabled = props.disabled,
      labelText = props.labelText,
      helperText = props.helperText,
      width = props.width,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      dataTest = props['data-test'],
      givenOnChange = props.onChange,
      givenOnFocus = props.onFocus,
      givenOnBlur = props.onBlur,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      theme = props.theme,
      remainingInputProps = _objectWithoutProperties(props, ["inputId", "errorText", "errorCta", "className", "leadingIcon", "trailingIcon", "value", "disabled", "labelText", "helperText", "width", "adjustToBackgroundColor", "data-test", "onChange", "onFocus", "onBlur", "type", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig(theme)
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      floatLabel = _useState2[0],
      setFloatLabel = _useState2[1];

  var floatOnFocus = function floatOnFocus(e) {
    setFloatLabel(true);
    if (givenOnFocus) givenOnFocus(e);
  };

  var unfloatOnBlur = function unfloatOnBlur(e) {
    setFloatLabel(false);
    if (givenOnBlur) givenOnBlur(e);
  };

  return /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    inputId: inputId,
    className: className,
    labelText: labelText,
    errorText: errorText,
    errorCta: errorCta,
    helperText: helperText,
    width: width,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor,
    isFloating: floatLabel || Boolean(value),
    setLabelOffset: type === 'date' || type === 'time',
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(FloatingStyledInput, _extends({
    customTheme: componentTheme
  }, remainingInputProps, {
    id: inputId,
    "data-test": dataTest || inputId,
    ref: ref,
    disabled: disabled,
    value: value,
    type: type,
    hasLeadingIcon: Boolean(leadingIcon),
    hasTrailingIcon: Boolean(trailingIcon),
    adjustToBackgroundColor: adjustToBackgroundColor // TODO: this formatting is not very fully fleshed-out
    ,
    onChange: function onChange(e) {
      givenOnChange(type !== 'tel' ? e.target.value : normalizePhoneNumber(e.target.value));
    },
    onFocus: floatOnFocus,
    onBlur: unfloatOnBlur
  })));
});
FloatingInput.displayName = 'FloatingInput';
export default FloatingInput;